<script src="../../public/windy.js"></script>
<script>
import axios from "axios";
import { pinyin } from "pinyin-pro";

export default {
  name: "MapComponent",
  filters: {
    invertPY: function (value) {
      var regText = /^[\u4e00-\u9fa5]/;
      var reg = new RegExp(regText);
      if (!reg.test(value)) {
        return value;
      }
      var py = pinyin(value, { toneType: "none" });
      py = py.toUpperCase();
      var reg = /^[0-9]+.?[0-9]*$/;
      var index;
      for (let i = 0; i < py.length; i++) {
        if (reg.test(py[i])) {
          index = i;
          break;
        }
      }
      var piny = py.substring(0, index);
      var shuzi = py.substring(index, py.length);
      shuzi = shuzi.replace(/\s*/g, "");
      value = value + " - " + piny + shuzi;
      return value;
    },
    capitalizeUtc: function (value) {
      return new Date(parseInt(value) * 1000).toLocaleString("zh", {
        hour12: false,
      });
    },
    filterNine: function (value) {
      if (value !== "") {
        if (value === "999999") {
          return (value = "");
        }
        return value + "°";
      }
    },
  },
  directives: {
    drag(el) {
      const oDiv = el; // 当前元素
      // let self = this // 上下文
      // 禁止选择网页上的文字
      /*       document.onselectstart = function () {
              return false
            } */
      oDiv.onmousedown = function (e) {
        if (e.target.nodeName === "INPUT" || e.target.nodeName === "TEXTAREA") {
          return;
        }
        // 鼠标按下，计算当前元素距离可视区的距离
        const disX = e.clientX - oDiv.offsetLeft;
        const disY = e.clientY - oDiv.offsetTop;
        document.onmousemove = function (e) {
          // 通过事件委托，计算移动的距离
          const l = e.clientX - disX;
          const t = e.clientY - disY;
          // 移动当前元素
          oDiv.style.left = l + "px";
          oDiv.style.top = t + "px";
        };
        document.onmouseup = function (e) {
          document.onmousemove = null;
          document.onmouseup = null;
        };
        // return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
        return false;
      };
    },
  },
  data() {
    return {
      userInfo: {},
      forceUpdateKey: 0,
      GraphicsLayer: null,
      Graphic: null,
      esri: null,
      PictureMarkerSymbol: null,
      TextSymbol: null,
      SimpleMarkerSymbol: null,
      SimpleLineSymbol: null,
      Draw: "",
      PictureFillSymbol: "",
      SimpleFillSymbol: "",
      CartographicLineSymbol: "",
      Color: "",
      dom: "",
      on: "",
      geometryEngine: "",
      esriRequest: "",
      JSON: "",
      RasterLayer: "",
      map: "",
      AllShip: [],
      UpdateShip: [],
      zoom_Layer5_11: null,
      zoom_Layer12_19: null,
      zoom_Layer14_19: null,
      postShipLayer: null,
      wharfLayer: null,
      beaconLayer: null,
      fleetLayer: null,
      fleet_box_sign: false,
      fleetList: [],
      ship_info_box_sign: false,
      shipInfo: {},
      AllWharf: [],
      is_show_location_source_list_sign: false,
      location_source: "北斗",
      current_click_ship_layer: "", // 1 船队 2 ais
      currentLocationSource: "0",
      token: "",
      BASE_URL: "/api",
      // BASE_URL: 'http://192.168.31.38:2023',
      button: 0,
    };
  },

  mounted() {
    this.token = localStorage.getItem("token");


    var that = this;
    // 默认定位荆州
    var InitPoint = [112.2278, 30.3044];

    // 地图服务
    window.require(
      [
        "dijit/registry",
        "esri/map",
        "esri/dijit/Search",
        "esri/dijit/LayerList",
        "esri/InfoTemplate",
        "src/GaodeLayer",

        "esri/graphic",
        "esri/symbols/PictureMarkerSymbol",
        "esri/symbols/TextSymbol",
        "esri/symbols/SimpleMarkerSymbol",
        "esri/symbols/SimpleLineSymbol",
        "esri/toolbars/draw",
        "esri/symbols/PictureFillSymbol",
        "esri/symbols/SimpleFillSymbol",
        "esri/symbols/CartographicLineSymbol",
        "esri/Color",
        "esri/geometry/Polyline",
        "esri/geometry/geometryEngine",
        "esri/request",
        "dojo/json",
        "src/RasterLayer",

        "esri/layers/GraphicsLayer",
        "esri/layers/ArcGISTiledMapServiceLayer",
        "esri/layers/ArcGISDynamicMapServiceLayer",
        "esri/layers/WMSLayer",
        "esri/layers/WMSLayerInfo",
        "esri/layers/WebTiledLayer",
        "esri/SpatialReference",
        "esri/geometry/Extent",
        "dojo/dom",
        "dojo/on",
        "dojo/domReady!",
        "dojo/parser",
      ],
      function (
        registry,
        Map,
        Search,
        LayerList,
        InfoTemplate,
        GaodeLayer,
        Graphic,
        PictureMarkerSymbol,
        TextSymbol,
        SimpleMarkerSymbol,
        SimpleLineSymbol,
        Draw,
        PictureFillSymbol,
        SimpleFillSymbol,
        CartographicLineSymbol,
        Color,
        Polyline,
        geometryEngine,
        esriRequest,
        JSON,
        RasterLayer,
        GraphicsLayer,
        ArcGISTiledMapServiceLayer,
        ArcGISDynamicMapServiceLayer,
        WMSLayer,
        WMSLayerInfo,
        WebTiledLayer,
        SpatialReference,
        Extent,
        dom,
        on
      ) {
        that.GraphicsLayer = GraphicsLayer;
        that.Graphic = Graphic;
        that.esri = esri;
        that.PictureMarkerSymbol = PictureMarkerSymbol;
        that.TextSymbol = TextSymbol;
        that.SimpleMarkerSymbol = SimpleMarkerSymbol;
        that.SimpleLineSymbol = SimpleLineSymbol;
        that.Draw = Draw;
        that.PictureFillSymbol = PictureFillSymbol;
        that.SimpleFillSymbol = SimpleFillSymbol;
        that.CartographicLineSymbol = CartographicLineSymbol;
        that.Color = Color;
        that.dom = dom;
        that.on = on;
        that.geometryEngine = geometryEngine;
        that.esriRequest = esriRequest;
        that.JSON = JSON;
        that.RasterLayer = RasterLayer;

        var xmin = 114;
        var ymin = 30;
        var xmax = 114.57;
        var ymax = 30.7;

        // 设置启动范围
        var startExtent = new esri.geometry.Extent(
          xmin,
          ymin,
          xmax,
          ymax,
          new esri.SpatialReference({ wkid: 4326 })
        );

        var gdlayer = new GaodeLayer();
        that.map = new Map(that.$refs.map, {
          center: InitPoint,
          extent: startExtent,
          zoom: 6,
          maxZoom: 19,
          minZoom: 6,
          slider: true,
          showLabels: true,
          logo: false,
        });
        gdlayer.name = "高德地图";
        gdlayer.visible = false;

        //卫星地图
        // var burl =
        //     "https://{subDomain}.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={col}&TILEROW={row}&TILEMATRIX={level}&tk=";
        // var electronicmap = new ArcGISTiledMapServiceLayer(burl);
        // electronicmap.visible = true;
        // electronicmap.name = "卫星地图";
        // electronicmap.copyright = null;
        // console.log(electronicmap);

        // 调用天地图
        var key = "28cf305854455f40f00922eeedec8218";
        // var URL_VECTOR_MERCATOR =
        //   // "http://{subDomain}.tianditu.com/DataServer?T=vec_w&x={col}&y={row}&l={level}&tk="; // 矢量底图
        //     "https://{subDomain}.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={col}&TILEROW={row}&TILEMATRIX={level}&tk="
        var URL_VECTOR_ANNOTATION_CHINESE_MERCATOR =
            "https://{subDomain}.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={col}&TILEROW={row}&TILEMATRIX={level}&tk="
        var URL_VECTOR_MERCATOR =
            "https://{subDomain}.tianditu.gov.cn/cva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={col}&TILEROW={row}&TILEMATRIX={level}&tk="

        var URL_VECTOR_WXDT =
            "https://{subDomain}.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={col}&TILEROW={row}&TILEMATRIX={level}&tk=";

        // 卫星地图标注图
        // "https://{subDomain}.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={col}&TILEMATRIX={level}&TILEROW={row}&tk="

        var layer1 = WebTiledLayer(URL_VECTOR_MERCATOR + key, {
          subDomains: ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"],
        });

        var layer2 = WebTiledLayer(
          URL_VECTOR_ANNOTATION_CHINESE_MERCATOR + key,
          {
            subDomains: ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"],
          }
        );
        var layer3 = WebTiledLayer(
            URL_VECTOR_WXDT + key,
            {
              subDomains: ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"],
            }
        );
        layer2.name = "2D平面图";
        layer1.name = "地图标注";
        layer3.name = "卫星地图"

        //加载地图
        that.map.addLayer(layer2, 1); //2D平面图
        that.map.addLayer(layer3, 2); //卫星图
        that.map.addLayer(layer1, 3); //地图标注

        //江图
        var TiledLayer = new ArcGISTiledMapServiceLayer(
            "https://jiangtu.hytqtech.cn/arcgis/rest/services/JiangTu/MapServer"
        );
        TiledLayer.name = "江图";
        that.map.addLayer(TiledLayer, 3);

        // 初始化图层
        that.initLayer();
        that.getUserFleetMethod();

        // 显示缩放级别
        that.map.on("zoom-end", function (evt) {
          var zoom_lever = that.map.getLevel();
          if (zoom_lever > 11) {
            that.loadship();
          }

          var showMapLevel = document.getElementById("showmaplevel");
          showMapLevel.innerHTML = zoom_lever + "级";
        });

        // 鼠标移动
        // that.map.on('mouse-drag-end', function(evt) {
        //   var zoom_lever = that.map.getLevel()
        //   if (zoom_lever>11){
        //     that.loadship()
        //   }
        // })

        if (registry.byId("layerList_map")) {
          registry.byId("layerList_map").destroy();
        }
        var myWidget11 = new LayerList(
          {
            map: that.map,
            visible: false,
            layers: [
              { layer: TiledLayer },
              { layer: layer1 },
              { layer: layer2 },
              { layer: layer3 },
            ],
          },
          "layerList_map"
        );

        // 添加图层菜单
        var addLayers = document.querySelector(".addlayers");
        // var addLayersImg = document.querySelector('#addlayersimg')
        var addLayersJudge = false;
        addLayers.onclick = function () {
          if (addLayersJudge === false) {
            addLayersJudge = true;
            // addLayersImg.src = 'addlayers2.png'
            // addLayers.style.color = '#417AD5'
            $("#layerList_map").fadeIn();
          } else {
            addLayersJudge = false;
            // addLayersImg.src = 'addlayers.png'
            // addLayers.style.color = '#707070'
            $("#layerList_map").fadeOut();
          }
        };

        myWidget11.startup();
      }
    );

    // setInterval(() => {
    //   //需要定时执行的代码
    //   // console.log(this.userInfo.dept.deptName)
    //   var zoom_lever = that.map.getLevel()
    //   if (this.currentLocationSource==='2'){
    //     if (zoom_lever>12){
    //       that.loadUserFleet()
    //     }else {
    //       that.loadUserFleet()
    //       that.updateKuang()
    //     }
    //   }else {
    //     axios({
    //         url: this.BASE_URL + '/work/ship_info/getUserFleet/'+this.currentLocationSource,
    //         method: 'get',
    //         headers: {
    //           'authorization': this.token
    //         }
    //   }).then((res)=>{
    //       // console.log(res)
    //       if (res.code===200){
    //         that.fleetList=res.data
    //         that.loadUserFleet()
    //       }
    //     })
    //   }
    // }, 30000)
  },
  watch: {},
  methods: {
    // 加载图层
    initLayer() {
      // 创建船舶图层
      this.zoom_Layer5_11 = new this.GraphicsLayer();
      this.zoom_Layer5_11.name = "船舶5-11";
      this.zoom_Layer5_11.setMaxScale(250000);
      this.map.addLayer(this.zoom_Layer5_11, 5);

      this.zoom_Layer12_19 = new this.GraphicsLayer();
      this.zoom_Layer12_19.name = "船舶12-19";
      this.zoom_Layer12_19.setMinScale(230000);
      this.map.addLayer(this.zoom_Layer12_19, 5);

      this.zoom_Layer14_19 = new this.GraphicsLayer();
      this.zoom_Layer14_19.name = "船舶14-19";
      this.zoom_Layer14_19.setMinScale(60000);
      this.map.addLayer(this.zoom_Layer14_19, 6);

      this.postShipLayer = new this.GraphicsLayer();
      this.postShipLayer.name = "定位船舶";
      this.map.addLayer(this.postShipLayer);

      // 航标图层
      this.beaconLayer = new this.GraphicsLayer();
      this.beaconLayer.name = "航标";
      this.beaconLayer.setMinScale(50000);
      this.map.addLayer(this.beaconLayer);

      // 创建码头图层
      this.wharfLayer = new this.GraphicsLayer();
      this.wharfLayer.name = "码头";
      this.wharfLayer.setMinScale(60000);
      this.map.addLayer(this.wharfLayer);

      // 船队图层
      this.fleetLayer = new this.GraphicsLayer();
      this.fleetLayer.name = "船队";
      this.map.addLayer(this.fleetLayer);

      this.fleetNameLayer = new this.GraphicsLayer();
      this.fleetNameLayer.name = "船队";
      this.map.addLayer(this.fleetNameLayer);
      return;
    },
    async HomeShipInfo(isCent = true) {
      // 加载船舶
      var point = this.map.geographicExtent;
      var shipcoordinatequery = {
        llat: 27.740368989632703,
        llng: 95.38575898437757,
        rlat: 38.254091628740085,
        rlng: 129.0698410156186,
      };
      console.log(shipcoordinatequery);
      let response = await axios.post(
        "http://58.48.124.172:20220/goadminapi/api/v1/ship-location2/queryupdate",
        shipcoordinatequery
      );
      let res = response.data;
      console.log(res);
      if (res.code === 200) {
        this.AllShip = res;
        var pointSimpol_green = new this.SimpleMarkerSymbol();
        pointSimpol_green.style = "diamond";
        pointSimpol_green.size = 8;
        pointSimpol_green.color = [53, 169, 83];
        pointSimpol_green.outline.color = [0, 255, 0, 0.5];

        this.updateKuang();
        this.getAisInZero();
      }

      this.zoom_Layer12_19.on("click", async (e) => {
        var time_now = new Date().getTime() / 1000;

        if (time_now - this.click_time_last < 1.5) {
          this.$message.info("您的操作频率过快，请稍后重试！");
          return;
        }
        this.click_time_last = time_now; //更新点击时间

        this.postShip(e.graphic.attributes);
        this.current_click_ship_layer = 2;
      });
    },
    // 初次加载所有船舶
    async InitShipInMap(data, pointSimpol_green) {
      // console.log(data)
      if (data.code === 200) {
        console.log(data.data.length);

        for (let i = 0; i < data.data.length; i++) {
          const point = [data.data[i].lng, data.data[i].lat];

          if (data.data[i].lng < 110.5 && i % 2 !== 0) {
            continue;
          } else if (data.data[i].lng > 119 && i % 4 !== 0) {
            continue;
          } else if (i % 3 !== 0) {
            continue;
          }

          var pointGraphic = new this.Graphic(
            new this.esri.geometry.Point(point),
            pointSimpol_green
          );

          this.zoom_Layer5_11.add(pointGraphic);
        }
      }
    },
    // 地图缩放、移动时加载屏幕内船舶
    loadship() {
      var zoom_lever = this.map.getLevel();

      var mercator = this.map.extent;

      var lat_c_new = this.map.extent.getCenter().getLatitude();
      var lon_c_new = this.map.extent.getCenter().getLongitude();

      var maxlonlat = { x: mercator.xmax, y: mercator.ymax };
      var minlonlat = { x: mercator.xmin, y: mercator.ymin };
      var maxlonlat = this.mercator2lonlat(maxlonlat);
      var minlonlat = this.mercator2lonlat(minlonlat);

      var maxlon = (maxlonlat.x - minlonlat.x) * 0.4 + lon_c_new;
      var minlon = lon_c_new - (maxlonlat.x - minlonlat.x) * 0.41;
      var maxlat = (maxlonlat.y - minlonlat.y) * 0.41 + lat_c_new;
      var minlat = lat_c_new - (maxlonlat.y - minlonlat.y) * 0.41;

      this.UpdateShipInMap(minlon, minlat, maxlon, maxlat, zoom_lever);
    },
    async UpdateShipInMap(
      zoom_xmin,
      zoom_ymin,
      zoom_xmax,
      zoom_ymax,
      zoom_leverl
    ) {
      var data = [];
      var graphicblack = [];

      var timestamp = new Date().getTime() / 1000 - 4 * 60 * 60; //utc时间为世界时

      if (zoom_leverl > 11) {
        var shipcoordinatequery = {};
        shipcoordinatequery.llng = zoom_xmin;
        shipcoordinatequery.llat = zoom_ymin;
        shipcoordinatequery.rlng = zoom_xmax;
        shipcoordinatequery.rlat = zoom_ymax;

        // console.log(shipcoordinatequery)
        let response = await axios.post(
          "http://58.48.124.172:20220/goadminapi/api/v1/ship-location2/queryupdate",
          shipcoordinatequery
        );
        let data = response.data;
        // console.log('//////////////////')
        // console.log(data)

        if (data.code === 200) {
          this.UpdateShip = data;
        } else {
          this.loadship();
        }

        if (data.code === 200) {
          this.updateKuang();
          this.getAisInZero();

          // console.log(data)
          /*var num_rec = 0

          var dataNUM = data.data.length

          for (let i = 0; i < dataNUM; i++) {
            if (data.data[i].lng > zoom_xmax) {
              continue
            }
            if (data.data[i].lng < zoom_xmin) {
              continue
            }
            if (data.data[i].lat < zoom_ymin) {
              continue
            }
            if (data.data[i].lat > zoom_ymax) {
              continue
            }

            //2天前的船舶不显示
            // if (data.data[i].utc < timestamp || data.data[i].status === '2') {
            //   continue
            // }
            // console.log(121212)
            num_rec = num_rec + 1

            const point = [
              data.data[i].lng,
              data.data[i].lat
            ]

            var planeSimpol = new this.PictureMarkerSymbol({
              url: 'shipGreen.png',
              height: 25,
              width: 5,
              type: 'esriPMS'
            })

            planeSimpol.setAngle(data.data[i].cour)

            var pointGraphic = new this.Graphic(
              new this.esri.geometry.Point(point),
              planeSimpol
            )
            pointGraphic.attributes = data.data[i]

            this.zoom_Layer12_19.add(pointGraphic)

            //AIS船标显示船名
            var txtname = data.data[i].shipName

            if (data.data[i].shipName === '') {
              txtname = data.data[i].shipMmsi
            }

            if (zoom_leverl > 13 && txtname != null && txtname.length > 1) {
              // 计算船名长度
              var strlen = 0
              for (let i = 0; i < txtname.length; i++) {
                if (txtname.charCodeAt(i) > 255) {
                  // 如果是汉字，则字符串长度加2
                  strlen = strlen + 2
                } else {
                  strlen = strlen + 1
                }
              }
              // 抽稀少显示船名
              var linex = -0.00005// 线
              var liney = -0.000028

              if (zoom_leverl === 14) {
                linex = -0.0006
                liney = -0.0013
              } else if (zoom_leverl === 15) {
                linex = -0.00065
                liney = -0.0008
              } else if (zoom_leverl === 16) {
                linex = -0.00035
                liney = -0.00028
              } else if (zoom_leverl === 17) {
                linex = -0.00025
                liney = -0.00017
              } else if (zoom_leverl === 18) {
                linex = -0.00012
                liney = -0.00007
              }

              var _fontsize = 13
              var width = strlen * 0.5 * (_fontsize + 1)
              var height = _fontsize * 1.2

              // 加载指示线
              var polyline_ship = new esri.geometry.Polyline()
              var pp = new this.esri.geometry.Point(point)
              var pp1 = new this.esri.geometry.Point(point[0] - linex, point[1] - liney)
              polyline_ship.addPath([pp, pp1])
              // 创建线条的样式
              var lineSymbol_ship = new this.SimpleLineSymbol()
              lineSymbol_ship.style = 'solid'
              lineSymbol_ship.color = [0, 0, 0, 0.5]
              // 构建一个 线条图像
              var graphicline = new this.Graphic(polyline_ship, lineSymbol_ship)

              // 图层里面添加 线条
              this.zoom_Layer14_19.add(graphicline)

              var blackxmin = graphicline._extent.xmin - ((graphicline._extent.xmax - graphicline._extent.xmin) / 5) * strlen
              var blackymin = graphicline._extent.ymin - (graphicline._extent.ymax - graphicline._extent.ymin) * 0.6
              var blackxmax = graphicline._extent.xmax + ((graphicline._extent.xmax - graphicline._extent.xmin) / 3) * strlen
              var blackymax = graphicline._extent.ymax + (graphicline._extent.ymax - graphicline._extent.ymin) * 1.5
              var blacks = {xmin: blackxmin, ymin: blackymin, xmax: blackxmax, ymax: blackymax}

              var flag = true
              if (graphicblack.length > 1) {
                for (let i = 0; i < graphicblack.length; i++) {
                  if (blackxmin > graphicblack[i].xmin && blackxmin < graphicblack[i].xmax && blackymin > graphicblack[i].ymin && blackymin < graphicblack[i].ymax) {
                    flag = false
                    break
                  }
                  if (blackxmin > graphicblack[i].xmin && blackxmin < graphicblack[i].xmax && blackymax > graphicblack[i].ymin && blackymax < graphicblack[i].ymax) {
                    flag = false
                    break
                  }
                  if (blackxmax > graphicblack[i].xmin && blackxmax < graphicblack[i].xmax && blackymax > graphicblack[i].ymin && blackymax < graphicblack[i].ymax) {
                    flag = false
                    break
                  }
                  if (blackxmax > graphicblack[i].xmin && blackxmax < graphicblack[i].xmax && blackymin > graphicblack[i].ymin && blackymin < graphicblack[i].ymax) {
                    flag = false
                    break
                  }
                }
              }

              if (flag === true || zoom_leverl === 19) {
                // 加载船名背景色
                var symbo_black = new this.PictureMarkerSymbol({
                  type: 'esriPMS'
                })

                symbo_black.url = 'gray.png'
                symbo_black.width = width
                symbo_black.height = height
                symbo_black.setOffset(35, 22)
                symbo_black.color.a = 0.7

                var graphic_black = new this.Graphic(new this.esri.geometry.Point(point), symbo_black)
                this.zoom_Layer14_19.add(graphic_black)
                // 加载船名
                var TextSymbol1 = new this.TextSymbol()

                TextSymbol1.setOffset(35, 18)
                TextSymbol1.setKerning(true)
                TextSymbol1.setText(txtname)
                TextSymbol1.font.size = _fontsize
                TextSymbol1.font.weight = 'bold'
                TextSymbol1.setColor([0, 0, 0, 1])


                var pointGraphic1 = new this.Graphic(
                  new this.esri.geometry.Point(point),
                  TextSymbol1
                )
                pointGraphic1.attributes = data.data[i]
                this.zoom_Layer14_19.add(pointGraphic1)

                graphicblack.push(blacks)
              } else {
                this.zoom_Layer14_19.remove(graphicline)
                // 加载下方指示线

                var polyline_ship_1 = new esri.geometry.Polyline()
                var pp_1 = new this.esri.geometry.Point(point[0] - linex, point[1] - (-1) * liney)// +的话就变成字符串操作
                polyline_ship_1.addPath([pp, pp_1])
                // 构建一个 线条图像
                var graphicline_1 = new this.Graphic(polyline_ship_1, lineSymbol_ship)
                this.zoom_Layer14_19.add(graphicline_1)

                blackxmin = graphicline_1._extent.xmin - ((graphicline_1._extent.xmax - graphicline_1._extent.xmin) / 5) * strlen
                blackymin = graphicline_1._extent.ymin - (graphicline_1._extent.ymax - graphicline_1._extent.ymin) * 1.5
                blackxmax = graphicline_1._extent.xmax + ((graphicline_1._extent.xmax - graphicline_1._extent.xmin) / 2.5) * strlen
                blackymax = graphicline_1._extent.ymax + (graphicline_1._extent.ymax - graphicline_1._extent.ymin)
                blacks = {xmin: blackxmin, ymin: blackymin, xmax: blackxmax, ymax: blackymax}

                flag = true
                if (graphicblack.length > 1) {
                  for (let i = 0; i < graphicblack.length; i++) {
                    if (blackxmin > graphicblack[i].xmin && blackxmin < graphicblack[i].xmax && blackymin > graphicblack[i].ymin && blackymin < graphicblack[i].ymax) {
                      flag = false
                      break
                    }
                    if (blackxmin > graphicblack[i].xmin && blackxmin < graphicblack[i].xmax && blackymax > graphicblack[i].ymin && blackymax < graphicblack[i].ymax) {
                      flag = false
                      break
                    }
                    if (blackxmax > graphicblack[i].xmin && blackxmax < graphicblack[i].xmax && blackymax > graphicblack[i].ymin && blackymax < graphicblack[i].ymax) {
                      flag = false
                      break
                    }
                    if (blackxmax > graphicblack[i].xmin && blackxmax < graphicblack[i].xmax && blackymin > graphicblack[i].ymin && blackymin < graphicblack[i].ymax) {
                      flag = false
                      break
                    }
                  }
                }

                if (flag === true) {
                  // 加载船名背景色
                  var symbo_black = new this.PictureMarkerSymbol({
                    type: 'esriPMS'
                  })

                  symbo_black.url = 'gray.png'
                  symbo_black.width = width + 5
                  symbo_black.height = height
                  symbo_black.setOffset(0, -18)
                  symbo_black.color.a = 0.7
                  // symbo_black.opacity=1
                  var graphic_black = new this.Graphic(new this.esri.geometry.Point(point), symbo_black)
                  this.zoom_Layer14_19.add(graphic_black)
                  // 加载船名
                  var TextSymbol1 = new this.TextSymbol()

                  TextSymbol1.setOffset(0, -22)
                  TextSymbol1.setKerning(true)
                  TextSymbol1.setText(txtname)
                  TextSymbol1.font.size = _fontsize
                  TextSymbol1.font.weight = 'bold'
                  TextSymbol1.setColor([0, 0, 0, 1])

                  var pointGraphic1 = new this.Graphic(
                    new this.esri.geometry.Point(point),
                    TextSymbol1
                  )
                  pointGraphic1.attributes = data.data[i]
                  this.zoom_Layer14_19.add(pointGraphic1)

                  graphicblack.push(blacks)
                } else {
                  this.zoom_Layer14_19.remove(graphicline_1)
                }
              }
            }
          }
*/
          var showMapLevel = document.getElementById("showmaplevel");
          showMapLevel.innerHTML = zoom_leverl + "级";
        }
      }
    },
    // 计算经纬度
    mercator2lonlat(mercator) {
      var lonlat = { x: 0, y: 0 };
      var x = (mercator.x / 20037508.34) * 180;
      var y = (mercator.y / 20037508.34) * 180;
      y =
        (180 / Math.PI) *
        (2 * Math.atan(Math.exp((y * Math.PI) / 180)) - Math.PI / 2);
      lonlat.x = x;
      lonlat.y = y;
      return lonlat;
    },
    getUserFleetMethod() {
      axios({
        url: this.$root.BASE_URL +
            "/work/ship_info/getUserFleet/" +
            this.currentLocationSource,
        method: "get",
        headers: {
          authorization: this.token,
        },
      }).then((res) => {
        if (res.data.code === 200) {
          this.fleetList = res.data.data;
          this.loadUserFleet();
          console.log(456)

        }
      });
    },
    // 加载船队
    loadUserFleet() {
      if (this.fleetLayer !== null) {
        this.fleetLayer.clear();
      }
      if (this.fleetNameLayer !== null) {
        this.fleetNameLayer.clear();
      }
      var graphicblack = [];

      console.log(123)

      for (let i = 0; i < this.fleetList.length; i++) {
        let ship = this.fleetList[i];
        // 加船的图标
        var point = [ship.lng, ship.lat];
        var planeSimpolSelect;
        if (this.currentLocationSource === "0") {
          planeSimpolSelect = new this.PictureMarkerSymbol({
            url: "ship3.png",
            height: 15,
            width: 15,
            type: "esriPMS",
          });
        } else if (this.currentLocationSource === "1") {
          planeSimpolSelect = new this.PictureMarkerSymbol({
            url: "ship4.png",
            height: 15,
            width: 15,
            type: "esriPMS",
          });
        } else if (this.currentLocationSource === "2") {
          planeSimpolSelect = new this.PictureMarkerSymbol({
            url: "ship5.png",
            height: 15,
            width: 15,
            type: "esriPMS",
          });
        }

        // planeSimpolSelect.setAngle(ship.cour)
        var pointGraphic = new this.Graphic(
            new this.esri.geometry.Point(point),
            planeSimpolSelect
        );
        pointGraphic.attributes = ship;
        pointGraphic.name = ship.shipName;
        this.fleetLayer.add(pointGraphic);

        var zoom_level = this.map.getLevel();

        //AIS船标显示船名
        var txtname = ship.shipName;

        // 计算名长度
        var strlen = 0;
        for (let i = 0; i < txtname.length; i++) {
          if (txtname.charCodeAt(i) > 255) {
            // 如果是汉字，则字符串长度加2
            strlen = strlen + 3;
          } else {
            strlen = strlen + 1;
          }
        }

        var _fontsize = 13;
        var width = strlen * 0.5 * (_fontsize + 1);
        var height = _fontsize * 1.2;

        if (txtname !== null && txtname.length > 1) {
          // 抽稀少显示船名
          var linex = -0.00005; // 线
          var liney = -0.000078;

          if (zoom_level === 6) {
            linex = -0.4;
            liney = -0.5;
          } else if (zoom_level === 7) {
            linex = -0.08;
            liney = -0.35;
          } else if (zoom_level === 8) {
            linex = -0.08;
            liney = -0.2;
          } else if (zoom_level === 9) {
            linex = -0.08;
            liney = -0.09;
          } else if (zoom_level === 10) {
            linex = -0.04;
            liney = -0.06;
          } else if (zoom_level === 11) {
            linex = -0.008;
            liney = -0.03;
          } else if (zoom_level === 12) {
            linex = -0.008;
            liney = -0.01;
          } else if (zoom_level === 13) {
            linex = -0.008;
            liney = -0.009;
          } else if (zoom_level === 14) {
            linex = -0.001;
            liney = -0.005;
          } else if (zoom_level === 15) {
            linex = -0.00065;
            liney = -0.001;
          } else if (zoom_level === 16) {
            linex = -0.00035;
            liney = -0.0009;
          } else if (zoom_level === 17) {
            linex = -0.00025;
            liney = -0.0006;
          } else if (zoom_level === 18) {
            linex = -0.00012;
            liney = -0.0003;
          }

          // 加载指示线
          var polyline_ship = new esri.geometry.Polyline();
          var pp = new this.esri.geometry.Point(point);
          var pp1 = new this.esri.geometry.Point(
              point[0] - linex,
              point[1] - liney
          );
          polyline_ship.addPath([pp, pp1]);
          // 创建线条的样式
          var lineSymbol_ship = new this.SimpleLineSymbol();
          lineSymbol_ship.style = "solid";
          lineSymbol_ship.color = [0, 0, 0, 0.4];
          // 构建一个 线条图像
          var graphicline = new this.Graphic(polyline_ship, lineSymbol_ship);

          // 图层里面添加 线条
          this.fleetNameLayer.add(graphicline);

          var blackxmin =
              graphicline._extent.xmax -
              ((graphicline._extent.xmax - graphicline._extent.xmin) / 35) *
              (width / 2);
          var blackxmax =
              graphicline._extent.xmax +
              ((graphicline._extent.xmax - graphicline._extent.xmin) / 35) *
              (width / 2);
          var blackymin =
              graphicline._extent.ymax -
              ((graphicline._extent.ymax - graphicline._extent.ymin) / 45) *
              (height / 2);
          var blackymax =
              graphicline._extent.ymax +
              ((graphicline._extent.ymax - graphicline._extent.ymin) / 45) *
              (height / 2);

          var blacks = {
            xmin: blackxmin,
            ymin: blackymin,
            xmax: blackxmax,
            ymax: blackymax,
          };

          var flag = true;
          if (graphicblack.length > 1) {
            for (let i = 0; i < graphicblack.length; i++) {
              if (
                  (blackxmin > graphicblack[i].xmin &&
                      blackxmin < graphicblack[i].xmax) ||
                  (blackxmax > graphicblack[i].xmin &&
                      blackxmax < graphicblack[i].xmax) ||
                  (blackymin > graphicblack[i].ymin &&
                      blackymin < graphicblack[i].ymax) ||
                  (blackymax > graphicblack[i].ymin &&
                      blackymax < graphicblack[i].ymax)
              ) {
                flag = false;
                break;
              }
            }
          }

          if (flag === true || zoom_level === 19) {
            // 添加时间
            // 加名背景

            var symbo_black_1 = new this.PictureMarkerSymbol({
              url: "gray2.png",
              type: "esriPMS",
            });
            // symbo_black_1.setOffset(40, 28);
            symbo_black_1.width = width;
            symbo_black_1.height = height;

            var graphic_black_1 = new this.Graphic(
                new this.esri.geometry.Point(pp1),
                symbo_black_1
            );
            this.fleetNameLayer.add(graphic_black_1);

            var TextSymbol1 = new this.TextSymbol();
            TextSymbol1.setOffset(0, -5);
            TextSymbol1.setKerning(true);
            TextSymbol1.setText(txtname);
            TextSymbol1.setColor("#212121");
            TextSymbol1.font.weight = "bold";

            var pointGraphic1 = new this.Graphic(
                new this.esri.geometry.Point(pp1),
                TextSymbol1
            );
            this.fleetNameLayer.add(pointGraphic1);

            graphicblack.push(blacks);
          } else {
            this.fleetNameLayer.remove(graphicline);
            // 加载下方指示线

            var polyline_ship_1 = new esri.geometry.Polyline();
            var pp_1 = new this.esri.geometry.Point(
                point[0] - linex,
                point[1] - -1 * liney
            ); // +的话就变成字符串操作
            polyline_ship_1.addPath([pp, pp_1]);
            // 构建一个 线条图像
            var graphicline_1 = new this.Graphic(
                polyline_ship_1,
                lineSymbol_ship
            );
            this.fleetNameLayer.add(graphicline_1);

            blackxmin =
                graphicline_1._extent.xmax -
                ((graphicline_1._extent.xmax - graphicline_1._extent.xmin) / 25) *
                (width / 2);
            blackxmax =
                graphicline_1._extent.xmax +
                ((graphicline_1._extent.xmax - graphicline_1._extent.xmin) / 25) *
                (width / 2);
            blackymin =
                graphicline_1._extent.ymin +
                ((graphicline_1._extent.ymax - graphicline_1._extent.ymin) / 35) *
                (height / 2);
            blackymax =
                graphicline_1._extent.ymin -
                ((graphicline_1._extent.ymax - graphicline_1._extent.ymin) / 35) *
                (height / 2);

            blacks = {
              xmin: blackxmin,
              ymin: blackymin,
              xmax: blackxmax,
              ymax: blackymax,
            };

            flag = true;
            if (graphicblack.length > 1) {
              for (let i = 0; i < graphicblack.length; i++) {
                if (
                    (blackxmin > graphicblack[i].xmin &&
                        blackxmin < graphicblack[i].xmax) ||
                    (blackxmax > graphicblack[i].xmin &&
                        blackxmax < graphicblack[i].xmax) ||
                    (blackymin > graphicblack[i].ymin &&
                        blackymin < graphicblack[i].ymax) ||
                    (blackymax > graphicblack[i].ymin &&
                        blackymax < graphicblack[i].ymax)
                ) {
                  flag = false;
                  break;
                }
              }
            }

            if (flag === true) {
              // 添加时间
              // 加名背景

              var symbo_black_2 = new this.PictureMarkerSymbol({
                url: "gray2.png",
                type: "esriPMS",
              });
              // symbo_black_2.setOffset(10, -25);
              symbo_black_2.width = width;
              symbo_black_2.height = height;

              var graphic_black_2 = new this.Graphic(
                  new this.esri.geometry.Point(pp_1),
                  symbo_black_2
              );
              this.fleetNameLayer.add(graphic_black_2);

              var TextSymbol2 = new this.TextSymbol();
              TextSymbol2.setOffset(0, -5);
              TextSymbol2.setKerning(true);
              TextSymbol2.setText(txtname);
              TextSymbol2.setColor("#212121");
              TextSymbol2.font.weight = "bold";

              var pointGraphic2 = new this.Graphic(
                  new this.esri.geometry.Point(pp_1),
                  TextSymbol2
              );
              this.fleetNameLayer.add(pointGraphic2);

              graphicblack.push(blacks);
            } else {
              this.fleetNameLayer.remove(graphicline_1);
              // 加载下方指示线

              var polyline_ship_2 = new esri.geometry.Polyline();
              var pp_2 = new this.esri.geometry.Point(
                  point[0] - -1 * linex,
                  point[1] - -1 * liney
              ); // +的话就变成字符串操作
              polyline_ship_2.addPath([pp, pp_2]);
              // 构建一个 线条图像
              var graphicline_2 = new this.Graphic(
                  polyline_ship_2,
                  lineSymbol_ship
              );
              this.fleetNameLayer.add(graphicline_2);

              blackxmin =
                  graphicline_2._extent.xmin -
                  ((graphicline_2._extent.xmax - graphicline_2._extent.xmin) /
                      25) *
                  (width / 2);
              blackxmax =
                  graphicline_2._extent.xmin +
                  ((graphicline_2._extent.xmax - graphicline_2._extent.xmin) /
                      25) *
                  (width / 2);
              blackymin =
                  graphicline_2._extent.ymin +
                  ((graphicline_2._extent.ymax - graphicline_2._extent.ymin) /
                      35) *
                  (height / 2);
              blackymax =
                  graphicline_2._extent.ymin -
                  ((graphicline_2._extent.ymax - graphicline_2._extent.ymin) /
                      35) *
                  (height / 2);

              blacks = {
                xmin: blackxmin,
                ymin: blackymin,
                xmax: blackxmax,
                ymax: blackymax,
              };

              flag = true;
              if (graphicblack.length > 1) {
                for (let i = 0; i < graphicblack.length; i++) {
                  if (
                      (blackxmin > graphicblack[i].xmin &&
                          blackxmin < graphicblack[i].xmax) ||
                      (blackxmax > graphicblack[i].xmin &&
                          blackxmax < graphicblack[i].xmax) ||
                      (blackymin > graphicblack[i].ymin &&
                          blackymin < graphicblack[i].ymax) ||
                      (blackymax > graphicblack[i].ymin &&
                          blackymax < graphicblack[i].ymax)
                  ) {
                    flag = false;
                    break;
                  }
                }
              }

              if (flag === true) {
                // 添加时间
                // 加名背景

                var symbo_black_3 = new this.PictureMarkerSymbol({
                  url: "gray2.png",
                  type: "esriPMS",
                });
                // symbo_black_2.setOffset(10, -25);
                symbo_black_3.width = width;
                symbo_black_3.height = height;

                var graphic_black_3 = new this.Graphic(
                    new this.esri.geometry.Point(pp_2),
                    symbo_black_3
                );
                this.fleetNameLayer.add(graphic_black_3);

                var TextSymbol3 = new this.TextSymbol();
                TextSymbol3.setOffset(0, -5);
                TextSymbol3.setKerning(true);
                TextSymbol3.setText(txtname);
                TextSymbol3.setColor("#212121");
                TextSymbol3.font.weight = "bold";

                var pointGraphic3 = new this.Graphic(
                    new this.esri.geometry.Point(pp_2),
                    TextSymbol3
                );
                this.fleetNameLayer.add(pointGraphic3);

                graphicblack.push(blacks);
              } else {
                this.fleetNameLayer.remove(graphicline_2);
                // 加载下方指示线

                var polyline_ship_3 = new esri.geometry.Polyline();
                var pp_3 = new this.esri.geometry.Point(
                    point[0] - -1 * linex,
                    point[1] - liney
                ); // +的话就变成字符串操作
                polyline_ship_3.addPath([pp, pp_3]);
                // 构建一个 线条图像
                var graphicline_3 = new this.Graphic(
                    polyline_ship_3,
                    lineSymbol_ship
                );
                this.fleetNameLayer.add(graphicline_3);

                blackxmin =
                    graphicline_3._extent.xmin -
                    ((graphicline_3._extent.xmax - graphicline_3._extent.xmin) /
                        25) *
                    (width / 2);
                blackxmax =
                    graphicline_3._extent.xmin +
                    ((graphicline_3._extent.xmax - graphicline_3._extent.xmin) /
                        25) *
                    (width / 2);
                blackymin =
                    graphicline_3._extent.ymax +
                    ((graphicline_3._extent.ymax - graphicline_3._extent.ymin) /
                        35) *
                    (height / 2);
                blackymax =
                    graphicline_3._extent.ymax -
                    ((graphicline_3._extent.ymax - graphicline_3._extent.ymin) /
                        35) *
                    (height / 2);

                blacks = {
                  xmin: blackxmin,
                  ymin: blackymin,
                  xmax: blackxmax,
                  ymax: blackymax,
                };

                flag = true;
                if (graphicblack.length > 1) {
                  for (let i = 0; i < graphicblack.length; i++) {
                    if (
                        (blackxmin > graphicblack[i].xmin &&
                            blackxmin < graphicblack[i].xmax) ||
                        (blackxmax > graphicblack[i].xmin &&
                            blackxmax < graphicblack[i].xmax) ||
                        (blackymin > graphicblack[i].ymin &&
                            blackymin < graphicblack[i].ymax) ||
                        (blackymax > graphicblack[i].ymin &&
                            blackymax < graphicblack[i].ymax)
                    ) {
                      flag = false;
                      break;
                    }
                  }
                }

                if (flag === true) {
                  // 添加时间
                  // 加名背景

                  var symbo_black_4 = new this.PictureMarkerSymbol({
                    url: "gray2.png",
                    type: "esriPMS",
                  });
                  // symbo_black_2.setOffset(10, -25);
                  symbo_black_4.width = width;
                  symbo_black_4.height = height;

                  var graphic_black_4 = new this.Graphic(
                      new this.esri.geometry.Point(pp_3),
                      symbo_black_4
                  );
                  this.fleetNameLayer.add(graphic_black_4);

                  var TextSymbol4 = new this.TextSymbol();
                  TextSymbol4.setOffset(0, -5);
                  TextSymbol4.setKerning(true);
                  TextSymbol4.setText(txtname);
                  TextSymbol4.setColor("#212121");
                  TextSymbol4.font.weight = "bold";

                  var pointGraphic4 = new this.Graphic(
                      new this.esri.geometry.Point(pp_3),
                      TextSymbol4
                  );
                  this.fleetNameLayer.add(pointGraphic4);

                  graphicblack.push(blacks);
                } else {
                  this.fleetNameLayer.remove(graphicline_3);
                }
              }
            }
          }
        }
      }
      // console.log(graphicblack);

      this.fleetLayer.on("click", async (e) => {
        if (this.trackSign) {
          this.$message.warning("请先退出轨迹回放");
          return;
        }
        this.current_click_ship_layer = 1;
        this.postShip(e.graphic.attributes);
        this.showShipInfoBox(e.graphic.attributes);
      });

      this.loading = false;
    },
    // 定位船舶
    postShip(shipInfo) {
      // console.log(shipInfo)
      if (this.postShipLayer !== null) {
        this.postShipLayer.clear();
      }
      var planeSimpol = new this.PictureMarkerSymbol({
        url: "aimShip.png",
        height: 25,
        width: 25,
        type: "esriPMS",
      });

      planeSimpol.setAngle(shipInfo.cour);
      const point_click = [shipInfo.lng, shipInfo.lat];

      var pointGraphic_click = new this.Graphic(
        new this.esri.geometry.Point(point_click),
        planeSimpol
      );

      pointGraphic_click.attributes = shipInfo;

      if (this.postShipLayer != null) {
        this.postShipLayer.clear();
      }
      this.postShipLayer.add(pointGraphic_click);
    },
    // 点击船队中的船事件
    clickShipInFleet(shipInfo) {
      console.log(shipInfo);
      if (
        shipInfo.lng === "" ||
        shipInfo.lat === "" ||
        shipInfo.lng === null ||
        shipInfo.lat === null
      ) {
        this.$message.info("船舶[" + shipInfo.shipName + "]暂无定位信息！");
        return;
      }
      this.current_click_ship_layer = 1;
      this.postShip(shipInfo);

      var point = [shipInfo.lng, shipInfo.lat];
      this.map.centerAndZoom(point, 12);
      this.showShipInfoBox(shipInfo);
    },
    // 显示船舶信息框
    showShipInfoBox(attributes) {
      this.ship_info_box_sign = true;
      this.shipInfo = attributes;
    },
    // 关闭船舶信息框
    closeShipInfoBox() {
      this.ship_info_box_sign = false;
      this.postShipLayer.clear();
    },
    // 更新红框
    updateKuang() {
      // 如果此时有定位船舶，更新定位船舶的框
      if (this.postShipLayer.graphics.length !== 0) {
        let shipCnnb = this.postShipLayer.graphics[0].attributes.shipCnnb;

        // console.log(this.current_click_ship_layer)

        if (this.current_click_ship_layer === 1) {
          this.fleetList.forEach((p) => {
            // console.log(p.shipCnnb)
            if (p.shipCnnb === shipCnnb) {
              this.postShip(p);
            }
          });
        } else {
          this.UpdateShip.data.forEach((p) => {
            if (p.shipCnnb === shipCnnb) {
              this.postShip(p);
            }
          });
        }
      }
    },
    // 跳转到摄像头
    jumpMonitor(item) {
      window.open(
        "http://cctv.hbrytech.cn:2123/monitorVideo/live?id=" + item.shipCnnb
      );
      // console.log(item)
      // this.$router.push({ path: "/monitorVideo/live", query: {id:item.shipCnnb} });
    },
    copyClick(value) {
      const input = document.createElement("input"); // 创建一个隐藏input（重要！）
      input.value = value; // 赋值
      document.body.appendChild(input);
      input.select(); // 选择对象
      if (document.execCommand("copy")) {
        document.execCommand("copy"); // 执行浏览器复制命令
        this.$message({ message: "复制成功", type: "success" });
      }
      document.body.removeChild(input);
    },
    show_location_source_list() {
      if (this.is_show_location_source_list_sign === false) {
        this.is_show_location_source_list_sign = true;
      } else {
        this.is_show_location_source_list_sign = false;
      }
    },
    zoomOutAndExpandMethod() {
      if (this.button === 1) {
        document.getElementById("fastmenu_box").style.width = "0px";
        document.getElementById("fastmenu_box").style.overflowX = "hidden";
        document.getElementById("zoomOutAndExpandImg").src = "left.png";
        this.button = 0;
      } else {
        document.getElementById("fastmenu_box").style.width = "320px";
        document.getElementById("fastmenu_box").style.overflow = "hidden";
        document.getElementById("zoomOutAndExpandImg").src = "right.png";
        this.button = 1;
      }
    },
  },
};
</script>

<template>
  <div class="page">
    <!--  屏幕右边地图   -->
    <div id="map-div" class="map-div">
      <div id="map" ref="map" />
      <div id="showmaplevel">6级</div>
      <div>
        <div class="zoomOutAndExpand" @click="zoomOutAndExpandMethod()">
          <img id="zoomOutAndExpandImg" src="left.png" width="12px" />
        </div>

        <div class="fastmenu_box" id="fastmenu_box">
          <a href="javascript:void(0)" @click="fleet_box_sign = true">
            <img src="fleet.png" />
            我的船队
            <i />
            <em />
          </a>
          <a href="javascript:void(0)" class="addlayers">
            <img id="addlayersimg" src="addlayers2.png" />
            图层显示
            <i />
            <em />
          </a>
          <a
            style="width: 100px"
            href="javascript:void(0)"
            @click="show_location_source_list"
          >
            <img src="location_source.png" />
            定位源
            <i />
            <em />
          </a>
        </div>

        <div id="layerList_map" />

        <div
          class="location_source_list"
          v-show="is_show_location_source_list_sign"
        >
          <el-radio-group
            v-model="currentLocationSource"
            @change="getUserFleetMethod()"
          >
            <el-radio label="0">北斗</el-radio>
            <el-radio label="2">基站AIS</el-radio>
            <el-radio label="1">船载AIS</el-radio>
          </el-radio-group>
        </div>
      </div>

      <!--      我的船队-->
      <div v-show="fleet_box_sign" v-drag id="fleetBox">
        <i
          class="el-icon-close"
          style="color: black"
          @click="fleet_box_sign = false"
        />
        <div class="fleet_title">我的船队</div>
        <div style="border-bottom: 1px silver solid"></div>
        <div class="fleetBoxCon">
          <div
            class="fleetItem"
            v-for="(item, index) in fleetList"
            @key="index"
          >
            <img src="ship1.png" class="fleetItemShipImg" />
            <span>{{ item.shipName }}</span>
            <img
              src="monitor.png"
              class="fleetItemMonImg"
              @click="jumpMonitor(item)"
            />
            <img
              src="position_red.png"
              class="fleetItemPostImg"
              @click="clickShipInFleet(item)"
            />

            <img
              v-if="currentLocationSource !== '0'"
              title="北斗"
              src="gps_grey.png"
              style="
                width: 18px;
                position: absolute;
                right: 53px;
                margin-top: 8px;
              "
            />
            <img
              v-if="currentLocationSource !== '2'"
              title="网络AIS"
              src="ais_grey.png"
              style="
                width: 18px;
                position: absolute;
                right: 30px;
                margin-top: 8px;
              "
            />
            <img
              v-if="currentLocationSource !== '1'"
              title="船载AIS"
              src="local_grey.png"
              style="
                width: 15px;
                position: absolute;
                right: 10px;
                margin-top: 9px;
              "
            />
            <img
              v-if="currentLocationSource === '0'"
              title="当前定位源北斗"
              src="gps.png"
              style="
                width: 18px;
                position: absolute;
                right: 53px;
                margin-top: 8px;
              "
            />
            <img
              v-if="currentLocationSource === '2'"
              title="当前定位源网络AIS"
              src="ais.png"
              style="
                width: 18px;
                position: absolute;
                right: 30px;
                margin-top: 8px;
              "
            />
            <img
              v-if="currentLocationSource === '1'"
              title="当前定位源船载AIS"
              src="local.png"
              style="
                width: 15px;
                position: absolute;
                right: 10px;
                margin-top: 9px;
              "
            />
          </div>
        </div>
      </div>

      <!--      船舶信息框-->
      <div v-show="ship_info_box_sign" v-drag id="shipInfoBox">
        <i class="el-icon-close" @click="closeShipInfoBox" />
        <div class="title-item">
          <div class="title-dp">
            <div style="display: flex">
              <div>
                <img
                  src="guoqi.png"
                  class="title-img"
                  style="border: 1px white solid"
                />
              </div>
              <div><img src="shipInInfoBox.png" class="title-img" /></div>
              <div
                class="title-text"
                :title="shipInfo.shipName | invertPY"
                @click="copyClick(shipInfo.shipName)"
              >
                {{ shipInfo.shipName | invertPY }}
              </div>
            </div>
          </div>
          <div class="title-xp">
            更新时间: {{ shipInfo.time | capitalizeUtc }}
            <span style="margin-left: 10px">来源:基站</span>
          </div>
        </div>
        <div style="margin-top: 70px">
          <div class="div-item">
            <div class="ais-detail-item">
              <div class="grid-ship-left">M M S I</div>
              <div class="grid-ship-right" @click="copyClick(shipInfo.mmsi)">
                <a href="javascript:">：{{ shipInfo.mmsi }}</a>
              </div>
              <div class="grid-ship-left">船艏</div>
              <div class="grid-ship-right">：{{ shipInfo.trueheading }}</div>
            </div>

            <div class="ais-detail-item">
              <div class="grid-ship-left">船舶识别号</div>
              <div class="grid-ship-right">：{{ shipInfo.shipCnnb }}</div>
              <div class="grid-ship-left">船向</div>
              <div class="grid-ship-right">：{{ shipInfo.cour }}°</div>
            </div>

            <div class="ais-detail-item">
              <div class="grid-ship-left">船港籍</div>
              <div class="grid-ship-right">：{{ shipInfo.regportName }}</div>
              <div class="grid-ship-left">船速</div>
              <div class="grid-ship-right">：{{ shipInfo.speed }}节</div>
            </div>

            <div class="ais-detail-item">
              <div class="grid-ship-left">船检登记号</div>
              <div class="grid-ship-right">：{{ shipInfo.shipInspectNo }}</div>
              <div class="grid-ship-left">经度</div>
              <div class="grid-ship-right">：{{ shipInfo.lng }}N</div>
            </div>

            <div class="ais-detail-item">
              <div class="grid-ship-left">初次登记号</div>
              <div class="grid-ship-right">：{{ shipInfo.shipFirstregNo }}</div>
              <div class="grid-ship-left">纬度</div>
              <div class="grid-ship-right">：{{ shipInfo.lat }}E</div>
            </div>

            <div class="ais-detail-item">
              <div class="grid-ship-left">建造年份</div>
              <div class="grid-ship-right">：{{ shipInfo.shipBuiltDate }}</div>
              <div class="grid-ship-left">海船内河船</div>
              <div class="grid-ship-right">：{{ shipInfo.shipRegionType }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.esriSimpleSliderTL {
  top: unset;
  left: unset;
  bottom: 8px;
  right: 8px;
}
.esriAttributionList {
  display: none;
}
#layerList_map {
  position: absolute;
  top: 170px;
  font-size: 12px;
  z-index: 50;
  right: 730px;
  background: white;
}
.esriSimpleSlider {
  border: none;
  box-shadow: 0 2px 2px rgb(0, 0, 0 / 25%);
  border-radius: 0px;
}

.esriSimpleSliderVertical .esriSimpleSliderIncrementButton {
  border-bottom: 0.5px solid #d0d0d0;
}
.esriLayerList .esriContainer {
  background-color: #ffffff;
  color: #313131;
  border: none;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.25) !important;
}

.esriLayerList .esriTitle {
  font-size: 13px;
  line-height: 16px;
  font-family: "微软雅黑";
}
.location_source_list {
  position: absolute;
  top: 179px;
  font-size: 12px;
  z-index: 50;
  right: 630px;
  background: white;
  width: 100px;
  margin-top: -2px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.25) !important;
}
.location_source_list .el-radio {
  padding-left: 10px;
  width: 100px;
  border-top: 2px solid #ccc;
  line-height: 36px;
}
</style>
<style scoped lang="scss">
.page {
  margin: 0;
  height: 100%;
  width: 100%;
  background-color: #f0f2f5;
  display: flex;
  align-items: stretch;
  //overflow-y: auto;
}

.page_left_type {
  display: flex;
  margin: 10px;
}
.type {
  cursor: pointer;
  line-height: 40px;
  text-align: center;
  width: 40px;
  height: 40px;
  border: #dadada 1px solid;
}

.type:hover {
  background-color: #f5f5f5;
}

.type1 {
  width: 100%;
  margin: 3px;
}
.type4 {
  width: 49.6%;
  margin: 0.1%;
  display: inline-block;
}
.type9 {
  width: 33%;
  margin: 0.1%;
  display: inline-block;
}
.map-div {
  width: 100%;
  height: 100%;
}
#map {
  height: 100%;
}
/* 右下角地图级别显示  */
#showmaplevel {
  position: absolute;
  bottom: 385px;
  left: 620px;
  z-index: 999;
  text-align: center;
  line-height: 30px;
  border-radius: 3px;
  font-size: 16px;
  background-color: rgba(255, 255, 255, 1);
  color: #333;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.27);
  width: 80px;
  height: 30px;
  opacity: 0.8;
}
#positionbutton {
  position: absolute;
  bottom: 50px;
  right: 140px;
  z-index: 999;
  border-radius: 3px;
  background-color: rgba(255, 255, 255, 1);
  color: #333;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.27);
  width: 30px;
  height: 30px;
  opacity: 0.8;
  text-align: center;
}
.ship_near_port {
  position: absolute;
  top: 30px;
  right: 30px;
  width: 300px;
  height: 300px;
  background: white;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.27);
}
.floating_window_title {
  height: 30px;
  background: #409eff;
  line-height: 30px;
  color: white;
  padding-left: 5px;
  font-size: 14px;
}
.floating_window_title img {
  position: absolute;
  right: 5px;
  top: 5px;
  width: 18px;
  cursor: pointer;
}
.zoomOutAndExpand {
  cursor: pointer;
  display: block;
  position: absolute;
  z-index: 100;
  background-color: #03050c;
  line-height: 39px;
  right: 615px;
  width: 17px;
  top: 130px;
  height: 38px;
}
/* 右侧悬浮菜单 */
.fastmenu_box {
  width: 0;
  overflow-x: hidden;
  transition: width 0.2s;
  position: absolute;
  z-index: 100;
  background-color: #03050c;
  line-height: 37px;
  right: 630px;
  top: 130px;
  height: 38px;
}
.fastmenu_box a {
  width: 110px;
  display: inline-block;
  font-size: 12px;
  color: #ffffff;
  padding-left: 10px;
  position: relative;
  font-family: "微软雅黑";
  text-decoration: none;
}

.fastmenu_box a img {
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 2px;
  margin-right: 6px;
  width: 17px;
  height: 17px;
  background-position-x: 0;
}

.fastmenu_box a i {
  display: inline-block;
  width: 0;
  height: 22px;
  border-right: 1px dashed #dddddd;
  vertical-align: middle;
  margin-bottom: 2px;
  margin-left: 10px;
}

#fleetBox {
  background: #ffffff;
  width: 300px;
  height: 250px;
  right: 630px;
  top: 170px;
  font-size: 12px;
  position: absolute;
  border: 1px solid #d3d3d3;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.25) !important;
  z-index: 999;
}
.box_title {
  width: 100%;
  height: 30px;
  background: #4384f1;
  color: white;
  padding-left: 5px;
  line-height: 30px;
}
.el-icon-close {
  position: absolute;
  right: 2px;
  font-size: 18px;
  cursor: pointer;
  color: white;
  top: 2px;
  z-index: 3;
}
.fleet_title {
  width: 100px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  margin-top: 10px;
  margin-left: 10px;
  background: #4384f1;
  color: white;
  font-weight: 600;
  font-size: 15px;
}
.fleetBoxCon {
  color: black;
  padding: 10px;
  background-color: #ffffff;
}
.fleetItem:nth-child(even) {
  line-height: 35px;
  font-size: 15px;
  position: relative;
  background: #ececec;
}
.fleetItem:nth-child(odd) {
  line-height: 35px;
  font-size: 15px;
  position: relative;
}

.fleetItemShipImg {
  width: 15px;
  margin-left: 10px;
  margin-right: 5px;
  vertical-align: middle;
  margin-top: -2px;
}
.fleetItemPostImg {
  width: 21px;
  position: absolute;
  right: 75px;
  margin-top: 6px;
  cursor: pointer;
}
.fleetItemMonImg {
  cursor: pointer;
  width: 16px;
  position: absolute;
  right: 100px;
  margin-top: 9px;
}
#shipInfoBox {
  background: #ffffff;
  color: black;
  width: 450px;
  height: 300px;
  left: 615px;
  top: 120px;
  font-size: 12px;
  position: absolute;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.25) !important;
  z-index: 999;
}

.title-item {
  z-index: 2;
  height: 50px;
  padding-left: 5px;
  background: #4485f2;
  float: left;
  color: white;
  width: 100%;
}
.title-img {
  height: 19px;
  margin: 0px 6px 7px 5px;
  vertical-align: middle;
}

.title-text {
  width: 400px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 4px;
  position: relative;
  display: inline-block;
  font-weight: 700;
}

.title-dp {
  height: 25px;
  margin-top: 5px;
  margin-bottom: 2px;
  font-size: 15px;
  display: flex;
}

.title-xp {
  line-height: 12px;
  margin-left: 5px;
  height: 25px;
  color: #ffffffe8;
}
.grid-ship-left {
  width: 100px;
  text-align-last: justify;
  margin-left: 15px;
}

.grid-ship-right {
  width: 200px;
  text-align: left;
  display: flex;
}
.ais-detail-item {
  display: flex;
  line-height: 30px;
}
.div-item {
  margin: -5px 15px 20px 5px;
}
</style>
